import { createApi } from "@reduxjs/toolkit/query/react";

import { createAuthBaseQuery } from "../../common/utils";
// @ts-ignore
import { HOSTNAME } from "../../constant/host";

export type ScheduleStatus = "off" | "maybe" | "normal";

export interface ScheduleItem {
  date: string;
  status: ScheduleStatus;
}

export interface ScheduleData {
  from: string;
  to: string;
  items: ScheduleItem[];
}

export interface ScheduleResponse {
  status: string;
  data: ScheduleData;
}

export interface GetScheduleParams {
  from: string;
  to: string;
}

export interface UpdateScheduleParams {
  from: string;
  to: string;
  items: ScheduleItem[];
}

export const meScheduleApi = createApi({
  reducerPath: "meScheduleApi",
  baseQuery: createAuthBaseQuery(HOSTNAME),
  tagTypes: ["MeSchedule"],
  endpoints: (builder) => ({
    getSchedule: builder.query<ScheduleResponse, GetScheduleParams>({
      query: ({ from, to }) => {
        const qs = new URLSearchParams({ from, to }).toString();
        return {
          url: `/api/me/schedule?${qs}`,
          method: "GET",
        };
      },
      providesTags: (_result, _error, { from, to }) => [
        { type: "MeSchedule", id: `${from}_${to}` },
      ],
    }),
    updateSchedule: builder.mutation<ScheduleResponse, UpdateScheduleParams>({
      query: (body) => ({
        url: `/api/me/schedule`,
        method: "PUT",
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        // 楽観更新: 送信した items でキャッシュを即時反映
        const patchResult = dispatch(
          meScheduleApi.util.updateQueryData(
            "getSchedule",
            { from: arg.from, to: arg.to },
            (draft) => {
              draft.data = {
                from: arg.from,
                to: arg.to,
                items: arg.items,
              };
            }
          )
        );
        try {
          const { data } = await queryFulfilled;
          // サーバー確定値で再同期
          dispatch(
            meScheduleApi.util.updateQueryData(
              "getSchedule",
              { from: arg.from, to: arg.to },
              (draft) => {
                draft.data = data.data;
              }
            )
          );
        } catch {
          patchResult.undo();
        }
      },
    }),
  }),
});

export const { useGetScheduleQuery, useUpdateScheduleMutation } = meScheduleApi;
